import React from "react";
import { Menu, MenuItem } from "@material-ui/core";
import { KIcon } from "@kyburz/kdesign-system";
import useSetState from "../hooks/useSetState";

interface menuType {
  icon: string;
  title: string;
  action: () => void;
  disabled?: boolean;
}
interface Props {
  menuItems?: menuType[];
  icon?: string;
}

const TableDropdown = ({
  icon = "more-vertical",
  menuItems = [
    { icon: "edit", title: "Edit", action: () => {} },
    { icon: "trash-2", title: "Delete", action: () => {} },
  ],
}: Props) => {
  const [{ anchorEl }, setState] = useSetState({
    anchorEl: null,
  });

  const handleClick = (event) => {
    const target = event?.currentTarget;
    setState({ anchorEl: target });
  };

  const handleClose = (action) => {
    setState({ anchorEl: null });
    if (action && {}.toString.call(action) === "[object Function]") {
      action();
    }
  };

  return (
    <div>
      <KIcon icon={icon} onClick={handleClick} />
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {menuItems.map((x) => (
          <MenuItem
            onClick={() => handleClose(x.action)}
            key={x.title}
            disabled={x.disabled || false}
          >
            <div style={{ display: "flex" }}>
              <KIcon icon={x.icon} />
              <div style={{ marginLeft: 16 }}>{x.title}</div>
            </div>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default TableDropdown;
